import { Icons } from "@types";

export type CpInlineNotificationIntent =
  | "base"
  | "neutral"
  | "brand"
  | "success"
  | "critical"
  | "warning";

type NotificationType = "info" | "warning" | "error";

// Map legacy type prop to new intent prop
// Note: warning maps to critical for now (same red), will map to warning (yellow) in the future
export const typeToIntentMap: Record<
  NotificationType,
  CpInlineNotificationIntent
> = {
  info: "brand",
  warning: "critical",
  error: "critical",
};

export const defaultIcons: Record<CpInlineNotificationIntent, Icons> = {
  base: "information-circle-open-large",
  neutral: "information-circle-open-large",
  brand: "information-circle-open-large",
  success: "checkmark-circle-open-large",
  critical: "alert-triangle-open-large",
  warning: "information-circle-open-large",
};

// CSS variable tokens for icon colors - used with CpIcon fill prop and CpButton fill prop
export const iconColorTokens: Record<CpInlineNotificationIntent, string> = {
  base: "var(--cp-color-inline-notification-text-base)",
  neutral: "var(--cp-color-inline-notification-text-neutral)",
  brand: "var(--cp-color-inline-notification-icon-brand)",
  success: "var(--cp-color-inline-notification-icon-success)",
  critical: "var(--cp-color-inline-notification-icon-critical)",
  warning: "var(--cp-color-inline-notification-icon-warning)",
};
